@if (isShort) {
  <span [title]="date | customDate: 'long'">
    {{ date | customDate }}
  </span>
} @else {
  <span title="date | customDate: 'long'">{{ date | customDate: "" }}</span>
}
